<template>
  <v-card elevation="3" class="rounded-lg">
    <v-card-text>
      <v-row>
        <v-col cols="8">
          <v-row>
            <v-col class="pb-0">
              <span class="black--text font-weight-bold">
                {{ prospect.name }} {{ prospect.lastName }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <span class="regulartext">
                {{ prospect.billingInformation.companyName }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <span>
                {{ prospect.email }}
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row class="fill-height text-end">
            <v-col cols="12">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"> mdi-dots-vertical</v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in menu" :key="index">
                    <v-list-item-title @click="selection(item.value)">{{
                      item.text
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" align-self="end" class="pb-0">
              <span class="smalltext"> {{ prospect.phone }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <DeleteUserModal
      v-model="showDeleteDialog"
      @deleteProspect="deleteProspect"
    />
    <MakeClientModal v-model="showMakeClientDialog" @makeClient="makeClient" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
//componets
import DeleteUserModal from "@/components/home/modals/DeleteUserModal.vue";
import MakeClientModal from "@/components/home/modals/MakeClientModal.vue";
export default {
  components: {
    DeleteUserModal,
    MakeClientModal,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    menu: [],
    showDeleteDialog: false,
    showMakeClientDialog: false,
  }),
  created() {
    this.menu = [
      { text: this.translations.label_make_client, value: "make_client" },
      { text: this.translations.label_update, value: "update" },
      { text: this.translations.delete, value: "delete" },
    ];
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
  methods: {
    selection(value) {
      switch (value) {
        case "make_client":
          this.showMakeClientDialog = true;
          break;
        case "update":
          this.$router.push(`/prospect-update-form/${this.prospect._id}`);
          break;
        case "delete":
          this.showDeleteDialog = true;
          break;
      }
    },
    deleteProspect() {
      this.$emit("deleteProspect");
    },
    makeClient() {
      this.$emit("makeClient");
    },
  },
};
</script>

<style scoped>
.smalltext {
  font-size: 0.92em;
}
.regulartext {
  font-size: 0.9em;
}
</style>
